<template>
  <div class="request-tables-container">
    <table class="table">
      <thead>
        <th class="t-w-15">参数</th>
        <th class="t-w-10">类型</th>
        <th class="t-w-10">是否必填</th>
        <th class="t-w-10">最大长度</th>
        <th class="t-w-40">描述</th>
        <th class="t-w-15">示例值</th>
      </thead>
      <tbody>
        <tr v-for="(item,index) in paramsData" :key="index">
          <td class="t-w-15">{{item.params}}</td>
          <td class="t-w-10">{{item.type}}</td>
          <td class="t-w-10">{{item.required?'是':'否'}}</td>
          <td class="t-w-10">{{item.length}}</td>
          <td class="t-w-40">
            <div class="desc-text">{{item.description.text}}</div>
            <div
              class="desc-text"
              v-for="(item,index) in item.description.value"
              :key="index"
            >{{item}}</div>
          </td>
          <td class="t-w-15">{{item.example}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  props: {
    paramsData: {
      type: [Array],
      required: true
    }
  },
  name: "Tables",
  data() {
    return {};
  }
};
</script>
<style lang="less" scoped>
.request-tables-container {
  .table {
    border: 1px solid #dedede;
    width: 100%;
    th {
      height: 56px;
      line-height: 56px;
      font-size: 14px;
      font-weight: 500;
      text-align: center;
      background-color: #fafafa;
      border: 1px solid #dedede;
    }
    .t-w-10 {
      width: 10%;
    }
    .t-w-15 {
      width: 15%;
    }
    .t-w-40 {
      width: 40%;
    }
    td {
      font-size: 14px;
      padding: 15px 15px;
      border: 1px solid #dedede;
    }
    .desc-text {
    }
  }
}
</style>